import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IStepperListProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    usePointerType
} from "../../../../helpers/pointer";
import type {
    StepperPartContentProps
} from "../../type";
import {
    getStepperMeasures
} from "../../stylesheet";
import {
    withStepperContext
} from "../../context";
import StepperItem from "../item";

const StepperListContent: FC<StepperPartContentProps<IStepperListProps>> = ({
    customTheme: customThemeProp,
    children,
    context,
    style,
    ...props
}) => {
    const {
        controlPaddings,
        controlHeights,
        shapeConfigs,
        touchTargets,
        typography,
        iconSizes,
        borders,
        spaces
    } = NCoreUIKitTheme.useContext(customThemeProp ?? context.customTheme);

    const pointerType = usePointerType();

    const measures = getStepperMeasures({
        orientation: context.orientation,
        isInSheet: context.isInSheet,
        size: context.size,
        controlPaddings,
        controlHeights,
        shapeConfigs,
        touchTargets,
        pointerType,
        typography,
        iconSizes,
        borders,
        spaces
    });

    const {
        container: containerDynamicStyle
    } = useStyles({
        orientation: context.orientation,
        isInSheet: context.isInSheet,
        measures,
        spaces
    });

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            stylesheet[context.orientation],
            containerDynamicStyle
        ]}
        role="list"
    >
        {
            children ?? context.steps.map((item) => <StepperItem
                index={item.index}
                key={item.key}
            />)
        }
    </View>;
};
export default withStepperContext("List", StepperListContent);
